import React from "react";
import PropTypes from "prop-types";
import { BaasicButton, BaasicModal, BaasicDropdown, BaasicDraggableModal } from 'core/components';
import { defaultTemplate } from "core/hoc";
import { Content } from "core/layouts";
import { observer } from "mobx-react";
import { CreateFacilityOrderTemplateNewFlowModal, FacilityOrderTemplateNewFlowPortalNoteModal, PatientInformationBarNewFlow } from "application/facility-order-new-flow/components";
import { FacilityOrderTemplateItemNewFlowCalculationModal, FacilityOrderTemplateItemNewFlowNoteModal, FacilityOrderTemplateItemNewFlowDeleteModal, FacilityOrderTemplateItemNewFlowDeleteQuestionModal, FacilityOrderTemplateNewFlowDeleteModal, FacilityOrderTemplateItemNewFlowActivatePatientModal } from "application/facility-order-new-flow/components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { DropDownButton, DropDownButtonItem, Button } from "@progress/kendo-react-buttons";
import { GlobalItemChangeListener } from 'core/components';
import { handleKeyDown, handlePaste } from 'core/utils';

const FacilityOrderTemplateNewFlowEditTemplate = function ({ facilityOrderTemplateNewFlowEditViewStore, disabled, disabledSendOrder }) {
	const {
		items,
		patient,
		isNewPatient,
		contentLoading,
		inactiveOptions,
		createFacilityOrderTemplateNewFlowModal,
		openCreateFacilityOrderTemplateNewFlowModal,
		facilityOrderTemplateNewFlowPortalNoteModal,
		facilityOrderTemplateItemNewFlowCalculationModal,
		facilityOrderTemplateItemNewFlowNoteModal,
		facilityOrderTemplateItemNewFlowDeleteModal,
		facilityOrderTemplateItemNewFlowDeleteQuestionModal,
		facilityOrderTemplateNewFlowDeleteModal,
		openFacilityOrderTemplateItemNewFlowActivatePatientModal,
		facilityOrderTemplateItemNewFlowActivatePatientModal,
		hospitalClassName,
		dischargedClassName,
		expiredClassName,
		activeClassName,
		isDisabledTableInactiveOption,
		isDisabledAddTemplate,
		facilityOrderNewFlowConfirmModal,
		isMasterPatient,
		activatingInProgress,
		facilityOrder,
		isQtyChange,
	} = facilityOrderTemplateNewFlowEditViewStore;
	
	return (
		items && items.length > 0 ?
			<div className="card--tertiary u-mar--bottom--sml--alt">
				<GlobalItemChangeListener isChanged={isQtyChange} />
				<Content loading={contentLoading}>
					<div className="card--tertiary__header">
						<div className="u-flex--default">
							<h4 className="card--tertiary__header__title">
								{patient && patient.lastName && `${patient.lastName}`}
								{patient && patient.lastName && patient.firstName && ', '}
								{patient && patient.firstName && `${patient.firstName}`}
							</h4>
							<PatientInformationBarNewFlow patient={patient} disabled={disabledSendOrder} facilityOrderNewFlowConfirmModal={facilityOrderNewFlowConfirmModal} role="Initial Intake" isNewPatient={isNewPatient} isMasterPatient={isMasterPatient} facilityOrder={facilityOrder} />
							{
								isNewPatient &&
								<div className="status status--sml status--success u-mar--left--sml">
									<p>New Patient</p>
								</div>
							}
						</div>
						<div className="card--tertiary__header__actions u-mar--left--auto">
							<BaasicButton className="btn btn--icon--sml-med btn--light is-plus u-mar--right--xsml" icon="u-icon u-icon--xmed u-icon--add-lined" onClick={() => openCreateFacilityOrderTemplateNewFlowModal()} label="" disabled={isDisabledAddTemplate || isDisabledTableInactiveOption || disabled || activatingInProgress} />
							<div className="segmented-control">
								{inactiveOptions ?
									<React.Fragment>
										<ReactTooltip positionStrategy="fixed" id="patientStatusBarTip" place="top" />
										<Button key={inactiveOptions[0].id} className={hospitalClassName} onClick={() => openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptions[0].id, true)} disabled={disabled || activatingInProgress}>{inactiveOptions[0].name}</Button>
										<Button key={inactiveOptions[1].id} className={dischargedClassName} onClick={() => openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptions[1].id, true)} disabled={disabled || activatingInProgress}>{inactiveOptions[1].name}</Button>
										<Button key={inactiveOptions[2].id} className={expiredClassName} onClick={() => openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptions[2].id, true)} disabled={disabled || activatingInProgress}>{inactiveOptions[2].name}</Button>
										<Button key={inactiveOptions[3].id} className={activeClassName} onClick={() => openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptions[3].id, true, true)} disabled={disabled || activatingInProgress}>{inactiveOptions[3].name}</Button>
									</React.Fragment> : null
								}
							</div>

						</div>
					</div>

					<ReactTooltip positionStrategy="fixed" id="registerTip" place="bottom" />
					<ReactTooltip positionStrategy="fixed" id="registerTipChangeReview" place="bottom" />
					<ReactTooltip positionStrategy="fixed" id="registerTipNoChange" place="bottom" />
					<ReactTooltip positionStrategy="fixed" id="registerTipDiscontinued" place="bottom" />

					<div className="card--tertiary__body">
						{items.map(item => {
							return (<FacilityOrderTemplateTable key={item.id} facilityOrderTemplateNewFlowEditViewStore={facilityOrderTemplateNewFlowEditViewStore} facilityOrderTemplate={item} disabled={disabled} />);
						})}
					</div>

					<BaasicModal modalParams={createFacilityOrderTemplateNewFlowModal} className="modal__content modal--xxlrg">
						<CreateFacilityOrderTemplateNewFlowModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderTemplateNewFlowPortalNoteModal}>
						<FacilityOrderTemplateNewFlowPortalNoteModal />
					</BaasicModal>

					<BaasicDraggableModal modalParams={facilityOrderTemplateItemNewFlowCalculationModal} className="modal__content modal--lrg">
						<FacilityOrderTemplateItemNewFlowCalculationModal />
					</BaasicDraggableModal>

					<BaasicModal modalParams={facilityOrderTemplateItemNewFlowNoteModal} className="modal__content modal--med">
						<FacilityOrderTemplateItemNewFlowNoteModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderTemplateItemNewFlowDeleteModal} className="modal__content modal--med">
						<FacilityOrderTemplateItemNewFlowDeleteModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderTemplateItemNewFlowDeleteQuestionModal} className="modal__content modal--med">
						<FacilityOrderTemplateItemNewFlowDeleteQuestionModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderTemplateNewFlowDeleteModal} className="modal__content modal--lrg">
						<FacilityOrderTemplateNewFlowDeleteModal />
					</BaasicModal>

					<BaasicModal modalParams={facilityOrderTemplateItemNewFlowActivatePatientModal} className="modal__content modal--med">
						<FacilityOrderTemplateItemNewFlowActivatePatientModal />
					</BaasicModal>
				</Content>
			</div>
			: <React.Fragment></React.Fragment>
	);
};

const FacilityOrderTemplateTable = observer(({ facilityOrderTemplateNewFlowEditViewStore, facilityOrderTemplate, disabled }) => {
	const {
		setNewFlowStatus,
		openFacilityOrderTemplateNewFlowPortalNoteModal,
		selectedStatusAbrv,
		addEmptyItem,
		productStore,
		editItem,
		saveItem,
		updateItem,
		deleteFacilityOrderTemplateItem,
		openFacilityOrderTemplateNewFlowDeleteModal,
		openFacilityOrderTemplateItemNewFlowCalculationModal,
		setSelectedInactiveOption,
		isDisabledTableInactiveOption,
		showDropdownTableInactiveOptions,
		showTemplateNote,
		isNoChangeClicked,
		inactiveOptions,
		setImportAction,
		setImportActionToDeleteAndAddItem,
		isMasterPatient,
		activatingInProgress,
		setItemToggle,
		insertImportActionId
	} = facilityOrderTemplateNewFlowEditViewStore;

	const isSelectedStatusNewOrder = selectedStatusAbrv === 'new-order';

	const productDropdownItemRender = (li, itemProps) => {
		const itemName = itemProps && itemProps.dataItem.description;
		const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && facilityOrderTemplate.itemCategory.abrv === "ostomy" ?
			<i className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i> : null;
		const itemChildren = (
			<span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
				<span style={{ flex: "1" }}> {li.props.children} </span>
				<span style={{ fontSize: "12px" }}> {isPreferredIcon} {itemName} </span>
			</span>
		);
		return React.cloneElement(li, li.props, itemChildren);
	}

	const handleDropDownItemsOnClick = async (e, facilityOrderTemplateId, setInactiveReason) => {
		if (e.item.text === "No changes") {
			setSelectedInactiveOption("no-change", facilityOrderTemplateId, setInactiveReason && selectedStatusAbrv === "discharge" ? inactiveOptions[3].id : null, true);
		}
		else if (e.item.text === "Change/Review") {
			setSelectedInactiveOption("change", facilityOrderTemplateId, setInactiveReason && selectedStatusAbrv === "discharge" ? inactiveOptions[3].id : null, true);
		}
		else if (e.item.text === "Discontinued") {
			setSelectedInactiveOption("discharge", facilityOrderTemplateId, null, true);
		}
	}

	const dropdownRef = React.createRef();
	return (
		<div className={`table--secondary__wrapper u-mar--bottom--med--condition ${disabled || activatingInProgress || (facilityOrderTemplate.facilityOrderTemplateItems && facilityOrderTemplate.facilityOrderTemplateItems.some(x => !x.productId)) ? 'is-add-new-disabled' : ''}`}>
			<table width="100%" className="table--secondary">
				<colgroup>
					<col width={400} />
					<col width={150} />
					<col width={90} />
					<col />
					<col width={70} />
				</colgroup>
				<thead>
					<tr>
						<th colSpan="5">
							<div className="u-flex--space-between">
								<label>{facilityOrderTemplate.subCategory.name}</label>
								<div className="card--tertiary__header__actions u-align--h--right">
									{
										<div className="card--tertiary__header__actions">
											{isSelectedStatusNewOrder &&
												<button className="btn btn--icon--med btn--light" onClick={() => openFacilityOrderTemplateNewFlowDeleteModal(facilityOrderTemplate.id)} disabled={(disabled) ? "disabled" : null}>
													<i className="u-icon u-icon--delete--primary u-icon--sml"></i>
												</button>}
										</div>
									}
									{
										showDropdownTableInactiveOptions && !isSelectedStatusNewOrder ?
											<DropDownButton
												fillMode={"solid"}
												themeColor={"primary"}
												onItemClick={(e) => handleDropDownItemsOnClick(e, facilityOrderTemplate.id, true)}
												buttonClass={`btn btn--base btn--ghost k-dropdown-button--icons is-standalone status--sqare ${facilityOrderTemplate.newFlowStatus.abrv === "no-change" ? "success" : facilityOrderTemplate.newFlowStatus.abrv === "change" ? "warning" : facilityOrderTemplate.newFlowStatus.abrv === "discharge" ? "danger" : ""}`}
												disabled={disabled}
												popupSettings={{
													animate: false,
													anchorAlign: { horizontal: "right", vertical: "bottom" },
													popupAlign: { horizontal: "right", vertical: "top" },
													popupClass: 'is-clean'
												}}
											>
												{facilityOrderTemplate.newFlowStatus.abrv !== "no-change" && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--success" text="No changes" />}
												{facilityOrderTemplate.newFlowStatus.abrv !== "change" && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--warning-triangle" text="Change/Review" />}
												{facilityOrderTemplate.newFlowStatus.abrv !== "discharge" && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Discontinued" />}
											</DropDownButton>
											: !isSelectedStatusNewOrder ?
												<div className="status--sqare__wrapper" data-tooltip-content={isDisabledTableInactiveOption ? "These actions are enabled only for active patients" : ""} data-tooltip-id={isDisabledTableInactiveOption ? "registerTip" : ""}>
													<Button className="status--sqare danger btn--rounded" onClick={() => openFacilityOrderTemplateNewFlowPortalNoteModal(facilityOrderTemplate.id, "discharge")} disabled={isDisabledTableInactiveOption || disabled || activatingInProgress} data-tooltip-content="Discontinued" data-tooltip-id="registerTipDiscontinued" />
													<Button className="status--sqare warning btn--rounded" onClick={() => openFacilityOrderTemplateNewFlowPortalNoteModal(facilityOrderTemplate.id, "change", false, false, null, false, true)} disabled={isDisabledTableInactiveOption || disabled || activatingInProgress} data-tooltip-content="Change / Review Needed" data-tooltip-id="registerTipChangeReview" />
													<Button className="status--sqare success btn--rounded" onClick={() => setNewFlowStatus("no-change", facilityOrderTemplate.id)} disabled={isDisabledTableInactiveOption || disabled || isNoChangeClicked || activatingInProgress} data-tooltip-content="No Changes" data-tooltip-id="registerTipNoChange" />
												</div> : null
									}
								</div>
							</div>
							{
								showTemplateNote &&
								<div className={`message message--med ${selectedStatusAbrv === "discharge" ? "message--note message--note--discontinued" : selectedStatusAbrv === "new-order" ? "message--primary" : "message--note"} u-mar--top--tny`}>
									<BaasicButton
										className="btn btn--icon"
										icon="u-icon u-icon--note--alt u-icon--sml u-mar--left--xtny"
										label=""
										onlyIcon={true}
										onClick={() => openFacilityOrderTemplateNewFlowPortalNoteModal(facilityOrderTemplate.id, selectedStatusAbrv, true, false, selectedStatusAbrv === "discharge" ? facilityOrderTemplate.inactiveReasonId : null)}
										disabled={activatingInProgress || disabled}
									></BaasicButton>
									{facilityOrderTemplate.portalNote}
								</div>
							}
						</th>
					</tr>
				</thead>
				<tbody>
					{facilityOrderTemplate.facilityOrderTemplateItems.map((item, index) => {
						var isFormula = (item && item.product && item.product.itemType && (item.product.itemType.abrv === 'bottle' || item.product.itemType.abrv === 'can')) || (item.product && item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155");
						if (!item.product && item.toggle) {
							setTimeout(() => {
								if (dropdownRef.current) {
									// v14 dropped the inner .k-dropdown-wrap — the DropDownList root element is the clickable toggle
									const toggle = dropdownRef.current.element;
									if (toggle) {
										setItemToggle(item);
										toggle.click();
									}
								}
							}, 0);
						}
						return (
							<tr key={item.id} className={`${(facilityOrderTemplate.importActionId != insertImportActionId && item.importActionId === insertImportActionId) ? "new-row" : (item.importAction && item.importAction.abrv === "delete" ? "deleted-row" : "")} ${!item.product ? "is-focused" : ""}`}>
								<td className="is-flex">
									{
										item.product ? <React.Fragment>{item.product.description} <span className="table__icons-wrapper u-mar--left--auto"> {!item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>}</span></React.Fragment> :
											<BaasicDropdown
												placeholder="Select item name..."
												store={productStore}
												value={item.product}
												className="input--table"
												itemRender={productDropdownItemRender}
												onChange={(e) => { saveItem(item, facilityOrderTemplate.facilityOrderTemplateItems, index, e.target.value, facilityOrderTemplate) }}
												customRef={dropdownRef}
											/>
									}
								</td>
								<td>
									{item.product && item.product.itemId}
								</td>
								<td className="table-col-input text-align-left">
									<ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + item.id} place="top" />
									{item.isTemplateQuantityChanged && <div className="table-col-input__notif" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.templateQuantity ? item.facilityOrderTemplateItemInitial.templateQuantity : "blank")}></div>}
									{item.product && (item.product.itemType && (item.product.itemType.abrv === "can" || item.product.itemType.abrv === "bottle") ?
										item.templateQuantity :
										<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
											onClick={(e) => e.target.select()}
											onKeyDown={handleKeyDown}
											onPaste={handlePaste}
											onChange={(e) => { editItem(item,e.target.value, 'templateQuantity') }}
											onBlur={() => { updateItem(item, facilityOrderTemplate, false) }}
											value={item.templateQuantity}
											type="number"
											min="0"
											disabled={disabled || activatingInProgress || isMasterPatient}
										/>)
									}
								</td>

								<td className="table-col-input">
									<ReactTooltip positionStrategy="fixed" id={"registerTipItemChangedNote" + item.id} place="top" />
									{item.isNoteChanged && <div className="table-col-input__notif" data-tooltip-id={"registerTipItemChangedNote" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.note ? item.facilityOrderTemplateItemInitial.note : "blank")}></div>}
									{(!isMasterPatient && isFormula ?
										<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
											onClick={() => openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplate.facilityOrderTemplateItems, index)}
											value={item.note}
											readOnly={true}
											disabled={disabled || activatingInProgress}
										/> :
										<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
											onClick={ isFormula ? () => openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplate.facilityOrderTemplateItems, index): (e) => e.target.select()}
											onChange={(e) => { item.note = e.target.value }}
											onBlur={() => { updateItem(item, facilityOrderTemplate, true) }}
											value={item.note}
											disabled={disabled || activatingInProgress}
											readOnly={isFormula}
										/>)
									}
								</td>
								{
									<td className="type--center is-hidden">
										<div className="table__icons">
											{item.importActionId && (item.importActionId !== insertImportActionId) && (
													<Button
														disabled={disabled || activatingInProgress}
														className="btn btn--icon"
														icon="u-icon u-icon--update-table u-icon--sml"
														label="Change"
														onlyIcon={true}
														onClick={() => setImportActionToDeleteAndAddItem(item, facilityOrderTemplate.facilityOrderTemplateItems, index, facilityOrderTemplate.id)}
														title={"Swap"}
													></Button>
												)}
											{item.importAction && item.importAction.abrv === "delete" ?
												<Button
													className="btn btn--icon is-delete"
													icon="u-icon u-icon--sml u-icon--undo--table"
													label="Undelete"
													onlyIcon={true}
													onClick={() => setImportAction(item, "update")}
													disabled={disabled || activatingInProgress}
													title={"Undo"}
												></Button>
												:
												<Button
													className="btn btn--icon is-delete"
													icon={`u-icon u-icon--sml ${!item.product ? "u-icon--close--table" : "u-icon--delete--primary"}`}
													label="Delete"
													onlyIcon={true}
													onClick={() => { deleteFacilityOrderTemplateItem(facilityOrderTemplate.facilityOrderTemplateItems, index, facilityOrderTemplate.id, true) }}
													disabled={disabled || activatingInProgress}
													title={!item.product ? "Cancel" : "Delete"}
												></Button>
											}
										</div>
									</td>
								}
							</tr>
						);
					})}
				</tbody>
			</table>
			{ !(facilityOrderTemplate.facilityOrderTemplateItems && facilityOrderTemplate.facilityOrderTemplateItems.some(x => !x.productId)) &&
				(<button className={`table--secondary__add-button${(disabled || activatingInProgress) ? ' is-disabled' : ''}`} onClick={() => addEmptyItem(facilityOrderTemplate.id)} disabled={(disabled || activatingInProgress) ? "disabled" : null}>
					<span></span>
				</button>)
			}
		</div>
	);
});

FacilityOrderTemplateNewFlowEditTemplate.propTypes = {
	facilityOrderTemplateNewFlowEditViewStore: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	disabledSendOrder: PropTypes.bool
};

FacilityOrderTemplateTable.propTypes = {
	facilityOrderTemplateNewFlowEditViewStore: PropTypes.object.isRequired,
	facilityOrderTemplate: PropTypes.object.isRequired,
	disabled: PropTypes.bool
};

export default defaultTemplate(FacilityOrderTemplateNewFlowEditTemplate);